<template>
  <div
    class="win pk-open-result"
    :class="'pk-result-count-' + winList.skins_info.length"
    role="dialog"
    aria-modal="true"
    aria-label="打开箱子结果"
  >
    <div class="pk-result-glow"></div>
    <header class="pk-result-header">
      <span>打开箱子完成</span>
      <h2>恭喜获得以下饰品</h2>
      <p>饰品已自动进入背包，可保留或回收为小麦。</p>
      <button type="button" aria-label="关闭结果" @click="winX">×</button>
    </header>

    <section class="pk-result-grid">
      <article v-for="(item, index) in winList.skins_info" :key="winList.player_skins_ids[index] || index">
        <div class="pk-result-art" :style="{ backgroundImage: 'url(' + item.background + ')' }">
          <img :src="item.img" alt="" />
        </div>
        <strong :title="item.name">{{ item.name }}</strong>
        <span class="pk-result-price">{{ Number(item.price).toFixed(2) }}<i aria-label="披萨币"></i></span>
        <button type="button" :disabled="recyclingIndex === index || recyclingAll" @click="winexchange(index)">
          {{ recyclingIndex === index ? "回收中" : "回收该饰品" }}
        </button>
      </article>
    </section>

    <footer class="pk-result-footer">
      <div class="pk-result-total">
        <span>本次饰品总价值</span>
        <strong>{{ total_price }}<i aria-label="披萨币"></i></strong>
      </div>
      <div class="pk-result-actions">
        <button type="button" class="pk-result-recycle" :disabled="recyclingAll || recyclingIndex !== null" @click="winexchange('99')">
          {{ recyclingAll ? "回收中" : "全部回收" }}
        </button>
        <button type="button" class="pk-result-store" :disabled="recyclingAll" @click="winget">放入背包</button>
        <button type="button" class="pk-result-continue" :disabled="recyclingAll" @click="continueOpen">继续打开箱子</button>
      </div>
    </footer>
  </div>
</template>

<script>
import Utils from "./../assets/js/util.js";
import { playUiSound } from "@/utils/pizzaSound";
export default {
  props: ["winList", "winState", "player_skins_ids"],
  data() {
    return {
      //winState: true,
      list4: [],
      total_price: 0,
      recyclingIndex: null,
      recyclingAll: false,
    };
  },
  methods: {
    winexchange(index) {
      const recycleAll = index === "99";
      if (this.recyclingAll || this.recyclingIndex !== null) return;
      this.recyclingAll = recycleAll;
      this.recyclingIndex = recycleAll ? null : index;
      const param = {
        player_skins_ids: recycleAll ? this.winList.player_skins_ids : [this.winList.player_skins_ids[index]],
      };
      this.$axios
        .post("/index/User/exchangeToMoneynew", this.$qs.stringify(param))
        .then((res) => {
          const data = res.data;
          if (data.status == 1) {
            playUiSound("sale");
            this.$store.commit("getMasonry", data.data.total_amount);
            Utils.$emit("masonry", data.data.total_amount);
            const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
            userInfo.masonry = data.data.total_amount;
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            this.$message({
              message: "回收成功，小麦已到账",
              type: "success",
            });
            if (recycleAll) {
              this.$emit("winexchange", false);
              return;
            }
            this.winList.skins_info.splice(index, 1);
            this.winList.player_skins_ids.splice(index, 1);
            this.calculateTotal();
            if (!this.winList.skins_info.length) this.$emit("winexchange", false);
          } else {
            this.$message.warning(data.msg || "回收失败，请稍后重试");
          }
        })
        .catch(() => this.$message.error("网络异常，回收请求未完成"))
        .finally(() => {
          this.recyclingIndex = null;
          this.recyclingAll = false;
        });
    },
    winget() {
      this.$message.success("饰品已放入背包");
      this.$emit("winget", false);
    },
    winX() {
      this.$emit("winX", false);
    },
    continueOpen() {
      this.$emit("continue");
    },
    calculateTotal() {
      this.total_price = this.winList.skins_info
        .reduce((total, item) => total + Number(item.price || 0), 0)
        .toFixed(2);
    },
  },
  mounted() {
    this.calculateTotal();
  },
};
</script>

<style lang="less" scoped>
.winm {
  padding-bottom: 80px !important;
  overflow: hidden;
}
.win {
  position: absolute;
  top: 50vh;
  left: 50vw;
  width: 450px;
  padding: 20px;
  position: relative;
  transform: translate(-50%, -50%);

  // padding-top: 0;
  .win-back {
    width: 100%;
    height: auto;
    position: absolute;
    top: 15%;
    left: 0;
    z-index: -10;
    animation: move 5s linear infinite;

    img {
      width: 100%;
      height: auto;
    }
  }

  @keyframes move {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .win-top {
    width: 100%;
    display: flex;
    justify-content: center;

    img {
      width: 76%;
      // height: 200px;
    }
  }

  .win-x {
    position: absolute;
    top: 6%;
    right: 30px;
    color: #e9b10e;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #e9b10e;
    text-align: center;
    line-height: 20px;
  }

  .win-x:hover {
    cursor: pointer;
  }

  .win-bot {
    width: 78%;
    margin: 20px auto;
    display: flex;
    align-items: center;
    & > div {
      flex: 1;
    }

    .win-span1 {
      width: 80%;
      height: 40px;
      border-radius: 5px;
      margin-right: 5px;
      background: url("../assets/img/anniu.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        color: #000000;
        font-weight: 600;
        font-size: 14px;
      }

      img {
        margin-left: 20px;
        margin-right: 5px;
        width: auto;
        height: 15px;
      }
    }

    .win-span1:hover {
      cursor: pointer;
    }

    .win-span2 {
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      color: #fff;
      background-color: #ffca18;
      width: 80%;
      border-radius: 5px;
      height: 40px;
      margin-left: 5px;
      line-height: 40px;
      color: #000;
      font-size: 14px;
      font-weight: bold;
    }

    .win-span2:hover {
      cursor: pointer;
    }
  }

  .win-con {
    display: flex;
    justify-content: center;

    ul {
      width: 60%;
      display: flex;
      justify-content: center;

      li {
        width: 100%;
        border-radius: 5px;
        overflow: hidden;

        .win-warp {
          width: 100%;
          background-color: #e2c873;
          position: relative;

          .win-img {
            padding: 10px;
            background-image: url("../assets/img/box-skins-blue.jpg");
            background-size: 100% 100%;

            img {
              width: 100%;
              height: auto;
            }
          }

          .win-img1 {
            background-image: url("../assets/img/box-skins-violet.jpg");
          }

          .win-img2 {
            background-image: url("../assets/img/box-skins-golden.jpg");
          }

          .win-text {
            text-overflow: ellipsis;
            position: absolute;
            width: 100px;
            text-align: center;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            bottom: 30px;
            font-size: 10px;
            color: rgb(248, 246, 246);
          }

          .win-textt {
            display: none;
            width: 100%;
            padding: 6px 0;
            background-color: #e2c873;
            // padding: 10px;
            //overflow: hidden;
            //white-space: nowrap;
            text-overflow: ellipsis;
            color: #000;
            font-size: 10px;
          }
        }
      }
    }
  }

  .win-con1 {
    display: flex;
    justify-content: center;

    ul {
      margin: -5px;
      width: 80%;
      display: flex;
      flex-flow: row wrap;

      //flex-wrap: wrap;
      li {
        margin: 5px;
        width: 50%;
        border-radius: 5px;

        .win-warp {
          width: 100%;
          position: relative;

          .win-img {
            padding: 10px;
            background-image: url("../assets/img/box-skins-blue.jpg");
            background-size: 100% 100%;

            img {
              width: 100%;
              height: auto;
            }
          }

          .win-img1 {
            background-image: url("../assets/img/box-skins-violet.jpg");
          }

          .win-img2 {
            background-image: url("../assets/img/box-skins-golden.jpg");
          }
          .win-text {
            text-overflow: ellipsis;
            position: absolute;
            width: 100px;
            text-align: center;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            bottom: 30px;
            font-size: 10px;
            color: white;
          }

          .win-textt {
            width: 100%;
            padding: 6px 0;
            background: url("../assets/img/anniu.png") no-repeat;
            background-size: 100% 100%;
            color: rgb(15, 15, 15);
            // padding: 10px;
            //overflow: hidden;
            //white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 10px;
          }
        }
      }
    }
  }

  .win-con2 {
    display: flex;
    justify-content: center;

    ul {
      margin: -5px;
      width: 80%;
      display: flex;
      flex-flow: row wrap;

      li {
        margin-top: 5px;
        overflow: hidden;
        min-width: 50%;
        max-width: 50%;
        border-radius: 5px;
        // background-color: #e2c873;

        .win-warp {
          border-radius: 5px;
          overflow: hidden;
          margin: 0 5px;
          width: 100%;
          position: relative;

          .win-img {
            // padding: 10px;
            background-image: url("../assets/img/box-skins-blue.jpg");
            background-size: 100% 100%;

            img {
              border-top-right-radius: 5px;
              width: 100%;
              height: auto;
            }
          }

          .win-img1 {
            background-image: url("../assets/img/box-skins-violet.jpg");
          }

          .win-img2 {
            background-image: url("../assets/img/box-skins-golden.jpg");
          }

          .win-text {
            text-overflow: ellipsis;
            position: absolute;
            width: 100px;
            text-align: center;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            bottom: 30px;
            font-size: 10px;
            color: white;
          }

          .win-textt {
            width: 100%;
            padding: 6px 0;
            background: url("../assets/img/anniu.png") no-repeat;
            background-size: 100% 100%;
            color: rgb(14, 13, 13);
            // padding: 10px;
            //overflow: hidden;
            //white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 10px;
          }
        }
      }
    }
  }

  .win-con3 {
    display: flex;
    justify-content: center;

    ul {
      margin: -5px;
      width: 80%;
      display: flex;
      flex-flow: row wrap;

      li {
        // margin: 5px;
        min-width: 50%;
        max-width: 50%;

        .win-warp {
          margin: 5px;
          border-radius: 5px;
          overflow: hidden;
          // width: 100%;
          position: relative;
          .win-img {
            padding: 10px;
            background-image: url("../assets/img/box-skins-blue.jpg");
            background-size: 100% 100%;

            img {
              width: 100%;
              height: auto;
            }
          }

          .win-img1 {
            background-image: url("../assets/img/box-skins-violet.jpg");
          }

          .win-img2 {
            background-image: url("../assets/img/box-skins-golden.jpg");
          }

          .win-text {
            text-overflow: ellipsis;
            position: absolute;
            width: 100px;
            text-align: center;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            bottom: 30px;
            font-size: 10px;
            color: white;
          }

          .win-textt {
            width: 100%;
            padding: 6px 0;
            background: url("../assets/img/anniu.png") no-repeat;
            background-size: 100% 100%;
            color: rgb(15, 15, 15);
            // padding: 10px;
            //overflow: hidden;
            //white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 10px;
          }
        }
      }
    }
  }

  .win-con4 {
    display: flex;
    justify-content: center;

    ul {
      margin: -5px;
      width: 80%;
      display: flex;
      flex-flow: row wrap;

      li {
        // margin: 5px;
        min-width: 50%;
        max-width: 50%;

        .win-warp {
          margin: 5px;
          border-radius: 5px;
          overflow: hidden;
          // width: 100%;
          position: relative;

          .win-img {
            padding: 10px;
            background-image: url("../assets/img/box-skins-blue.jpg");
            background-size: 100% 100%;

            img {
              width: 100%;
              height: auto;
            }
          }

          .win-img1 {
            background-image: url("../assets/img/box-skins-violet.jpg");
          }

          .win-img2 {
            background-image: url("../assets/img/box-skins-golden.jpg");
          }

          .win-text {
            text-overflow: ellipsis;
            position: absolute;
            width: 100px;
            text-align: center;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            bottom: 30px;
            font-size: 10px;
            color: white;
          }

          .win-textt {
            width: 100%;
            padding: 6px 0;
            // padding: 10px;
            //overflow: hidden;
            //white-space: nowrap;
            text-overflow: ellipsis;
            background: url("../assets/img/anniu.png") no-repeat;
            background-size: 100% 100%;
            color: rgb(2, 2, 2);
            font-size: 10px;
          }
        }
      }

      li:nth-child(1) {
        min-width: 45%;
        max-width: 45%;
        margin-left: 25%;
      }

      li:nth-child(2) {
        min-width: 50%;
        max-width: 50%;
      }
    }
  }
}
.win-conm {
  display: flex;
  justify-content: center;
  padding-top: 50px;

  ul {
    margin: -5px;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    margin: 40px 0;

    li {
      // margin: 5px;
      min-width: 40%;
      max-width: 40%;

      .win-warp {
        margin: 5px;
        border-radius: 5px;
        overflow: hidden;
        // width: 100%;
        position: relative;

        .win-img {
          padding: 10px;
          background-image: url("../assets/img/box-skins-blue.jpg");
          background-size: 100% 100%;

          img {
            width: 100%;
            height: auto;
          }
        }

        .win-img1 {
          background-image: url("../assets/img/box-skins-violet.jpg");
        }

        .win-img2 {
          background-image: url("../assets/img/box-skins-golden.jpg");
        }

        .win-text {
          text-overflow: ellipsis;
          position: absolute;
          width: 100px;
          text-align: center;
          left: 0;
          right: 0;
          margin-left: auto;
          margin-right: auto;
          bottom: 30px;
          font-size: 8px !important;
          color: white;
        }

        .win-textt {
          width: 100%;
          padding: 6px 0;
          background: url("../assets/img/anniu.png") no-repeat;
          background-size: 100% 100%;
          color: rgb(3, 3, 3);
          // padding: 10px;
          //overflow: hidden;
          //white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 10px;
        }
      }
    }

    li:nth-child(1) {
      min-width: 60%;
      max-width: 60%;
    }

    li:nth-child(2) {
      min-width: 60%;
      max-width: 60%;
    }
  }
}
.win-con1m {
  display: flex;
  justify-content: center;
  padding-top: 50px;
  ul {
    margin: -5px;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    margin: 40px 0;

    li {
      // margin: 5px;
      min-width: 40%;
      max-width: 40%;

      .win-warp {
        margin: 5px;
        border-radius: 5px;
        overflow: hidden;
        // width: 100%;
        position: relative;

        .win-img {
          padding: 10px;
          background-image: url("../assets/img/box-skins-blue.jpg");
          background-size: 100% 100%;

          img {
            width: 100%;
            height: auto;
          }
        }

        .win-img1 {
          background-image: url("../assets/img/box-skins-violet.jpg");
        }

        .win-img2 {
          background-image: url("../assets/img/box-skins-golden.jpg");
        }

        .win-text {
          text-overflow: ellipsis;
          position: absolute;
          width: 100px;
          text-align: center;
          left: 0;
          right: 0;
          margin-left: auto;
          margin-right: auto;
          bottom: 30px;
          font-size: 8px !important;
          color: white;
        }

        .win-textt {
          width: 100%;
          padding: 6px 0;
          background: url("../assets/img/anniu.png") no-repeat;
          background-size: 100% 100%;
          color: rgb(19, 18, 18);
          // padding: 10px;
          //overflow: hidden;
          //white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 10px;
        }
      }
    }

    li:nth-child(1) {
      min-width: 40%;
      max-width: 40%;
    }

    li:nth-child(2) {
      min-width: 40%;
      max-width: 40%;
    }
  }
}
.win-con2m {
  display: flex;
  justify-content: center;
  padding-top: 110px;

  ul {
    margin: -5px;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;

    li {
      // margin: 5px;
      min-width: 40%;
      max-width: 40%;

      .win-warp {
        margin: 5px;
        border-radius: 5px;
        overflow: hidden;
        // width: 100%;
        position: relative;

        .win-img {
          padding: 10px;
          background-image: url("../assets/img/box-skins-blue.jpg");
          background-size: 100% 100%;

          img {
            width: 100%;
            height: auto;
          }
        }

        .win-img1 {
          background-image: url("../assets/img/box-skins-violet.jpg");
        }

        .win-img2 {
          background-image: url("../assets/img/box-skins-golden.jpg");
        }

        .win-text {
          text-overflow: ellipsis;
          position: absolute;
          width: 100px;
          text-align: center;
          left: 0;
          right: 0;
          margin-left: auto;
          margin-right: auto;
          bottom: 30px;
          font-size: 8px !important;
          color: white;
        }

        .win-textt {
          width: 100%;
          padding: 6px 0;
          background: url("../assets/img/anniu.png") no-repeat;
          background-size: 100% 100%;
          color: rgb(10, 10, 10);
          // padding: 10px;
          //overflow: hidden;
          //white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 10px;
        }
      }
    }

    li:nth-child(1) {
      min-width: 40%;
      max-width: 40%;
    }

    li:nth-child(2) {
      min-width: 40%;
      max-width: 40%;
    }
  }
}
.win-con3m {
  display: flex;
  justify-content: center;
  padding-top: 110px;

  ul {
    margin: -5px;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;

    li {
      // margin: 5px;
      min-width: 40%;
      max-width: 40%;

      .win-warp {
        margin: 5px;
        border-radius: 5px;
        overflow: hidden;
        // width: 100%;
        position: relative;

        .win-img {
          padding: 10px;
          background-image: url("../assets/img/box-skins-blue.jpg");
          background-size: 100% 100%;

          img {
            width: 100%;
            height: auto;
          }
        }

        .win-img1 {
          background-image: url("../assets/img/box-skins-violet.jpg");
        }

        .win-img2 {
          background-image: url("../assets/img/box-skins-golden.jpg");
        }

        .win-text {
          text-overflow: ellipsis;
          position: absolute;
          width: 100px;
          text-align: center;
          left: 0;
          right: 0;
          margin-left: auto;
          margin-right: auto;
          bottom: 30px;
          font-size: 8px !important;
          color: white;
        }

        .win-textt {
          width: 100%;
          padding: 6px 0;
          background: url("../assets/img/anniu.png") no-repeat;
          background-size: 100% 100%;
          color: rgb(3, 3, 3);
          // padding: 10px;
          //overflow: hidden;
          //white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 10px;
        }
      }
    }

    li:nth-child(1) {
      min-width: 40%;
      max-width: 40%;
    }

    li:nth-child(2) {
      min-width: 40%;
      max-width: 40%;
    }
  }
}
.win-con4m {
  display: flex;
  justify-content: center;
  padding-top: 50px;

  ul {
    margin: -5px;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;

    li {
      // margin: 5px;
      min-width: 33%;
      max-width: 33%;

      .win-warp {
        margin: 5px;
        border-radius: 5px;
        overflow: hidden;
        // width: 100%;
        position: relative;

        .win-img {
          padding: 10px;
          background-image: url("../assets/img/box-skins-blue.jpg");
          background-size: 100% 100%;

          img {
            width: 100%;
            height: auto;
          }
        }

        .win-img1 {
          background-image: url("../assets/img/box-skins-violet.jpg");
        }

        .win-img2 {
          background-image: url("../assets/img/box-skins-golden.jpg");
        }

        .win-text {
          text-overflow: ellipsis;
          position: absolute;
          width: 100px;
          text-align: center;
          left: 0;
          right: 0;
          margin-left: auto;
          margin-right: auto;
          bottom: 30px;
          font-size: 8px !important;
          color: white;
        }

        .win-textt {
          width: 100%;
          padding: 6px 0;
          // padding: 10px;
          //overflow: hidden;
          //white-space: nowrap;
          text-overflow: ellipsis;
          background: url("../assets/img/anniu.png") no-repeat;
          background-size: 100% 100%;
          color: rgb(15, 15, 15);
          font-size: 10px;
        }
      }
    }

    li:nth-child(1) {
      min-width: 33%;
      max-width: 33%;
    }

    li:nth-child(2) {
      min-width: 33%;
      max-width: 33%;
    }
  }
}
@media screen and (max-width: 767px) {
  .openbox {
    .kai-box {
      padding: 0 !important;
    }

    .win-box {
      left: 0 !important;
      margin-left: 0 !important;
    }

    .win-box {
      .win {
        width: auto !important;

        .win-text {
          font-size: 14px;
        }
      }
    }
  }
}

/* Target-style opening result panel. Keep exchange and inventory actions unchanged. */
.win,
.win.winm {
  box-sizing: border-box;
  width: min(920px, calc(100vw - 48px));
  max-height: calc(100vh - 64px);
  padding: 28px 30px 26px;
  overflow-y: auto;
  border: 1px solid rgba(236, 216, 184, 0.3);
  border-bottom-color: #ff7a00;
  border-radius: 10px;
  background:
    radial-gradient(ellipse at 50% 0, rgba(255, 182, 67, 0.16), transparent 38%),
    linear-gradient(180deg, #292c3a 0%, #1e202c 100%);
  box-shadow:
    0 0 72px rgba(255, 130, 0, 0.12),
    0 28px 80px rgba(0, 0, 0, 0.62);
}

.win::before {
  content: "";
  position: absolute;
  left: 20%;
  right: 20%;
  top: 52px;
  height: 150px;
  pointer-events: none;
  background: radial-gradient(ellipse, rgba(255, 205, 120, 0.2), transparent 68%);
  filter: blur(12px);
}

.win-top {
  position: relative;
  height: 58px;
  align-items: center;
}

.win-top::after {
  content: "打开箱子结果";
  color: #f7f3e9;
  font-size: 25px;
  line-height: 58px;
  font-weight: 900;
  letter-spacing: 1px;
  text-shadow: 0 0 20px rgba(255, 194, 85, 0.24);
}

.win-top img,
.win-back {
  display: none;
}

.win-con,
.win-con1,
.win-con2,
.win-con3,
.win-con4,
.win-conm,
.win-con1m,
.win-con2m,
.win-con3m,
.win-con4m {
  padding: 16px 0 4px;
  display: block;
}

.win-con ul,
.win-con1 ul,
.win-con2 ul,
.win-con3 ul,
.win-con4 ul,
.win-conm ul,
.win-con1m ul,
.win-con2m ul,
.win-con3m ul,
.win-con4m ul {
  width: 100%;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(148px, 1fr));
  gap: 12px;
}

.win-con ul li,
.win-con1 ul li,
.win-con2 ul li,
.win-con3 ul li,
.win-con4 ul li,
.win-conm ul li,
.win-con1m ul li,
.win-con2m ul li,
.win-con3m ul li,
.win-con4m ul li {
  width: auto;
  min-width: 0;
  max-width: none;
  margin: 0;
  overflow: visible;
}

.win .win-warp {
  height: 214px;
  margin: 0;
  overflow: hidden;
  border: 1px solid rgba(84, 91, 116, 0.56);
  border-radius: 7px;
  background: #282b39;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025);
}

.win .win-img {
  box-sizing: border-box;
  width: 100%;
  height: 154px;
  padding: 14px;
  display: grid;
  place-items: center;
  background-size: cover;
  background-position: center;
}

.win .win-img img {
  width: 100%;
  max-width: 178px;
  height: 122px;
  object-fit: contain;
  filter: drop-shadow(0 16px 18px rgba(0, 0, 0, 0.44));
}

.win .win-text {
  position: static;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding: 0 10px;
  overflow: hidden;
  color: #f2f5fc;
  font-size: 12px;
  line-height: 30px;
  font-weight: 800;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.win .win-textt {
  box-sizing: border-box;
  height: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #edb145;
  font-size: 12px;
  background: rgba(237, 177, 69, 0.08);
  border-top: 1px solid rgba(237, 177, 69, 0.16);
}

.win-bot {
  width: 100%;
  margin: 22px 0 0;
  gap: 12px;
  justify-content: center;
}

.win-bot .win-span1,
.win-bot .win-span2 {
  box-sizing: border-box;
  flex: 0 1 220px;
  width: auto;
  height: 48px;
  margin: 0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 48px;
  font-weight: 900;
}

.win-bot .win-span1 {
  color: #ecd8b8;
  border: 1px solid #ecd8b8;
  background: transparent;
}

.win-bot .win-span1 span {
  color: #ecd8b8;
}

.win-bot .win-span1 img {
  margin-left: 10px;
}

.win-bot .win-span2 {
  color: #fff7df;
  background: linear-gradient(180deg, #ff920e, #f26900);
  box-shadow: 0 0 24px rgba(242, 105, 0, 0.24);
}

.win-x {
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  color: #aab2c3;
  border: 1px solid rgba(170, 178, 195, 0.42);
  border-radius: 5px;
  font-size: 0;
  line-height: 32px;
}

.win-x::after {
  content: "×";
  font-size: 22px;
}

@media screen and (max-width: 767px) {
  .win,
  .win.winm {
    width: calc(100vw - 24px);
    padding: 18px 14px 20px;
  }

  .win-con ul,
  .win-con1 ul,
  .win-con2 ul,
  .win-con3 ul,
  .win-con4 ul,
  .win-conm ul,
  .win-con1m ul,
  .win-con2m ul,
  .win-con3m ul,
  .win-con4m ul {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
}

.pk-open-result {
  box-sizing: border-box;
  width: min(980px, calc(100vw - 48px));
  max-height: calc(100vh - 40px);
  padding: 32px;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  overflow: auto;
  transform: translate(-50%, -50%);
  color: #f6f7fb;
  background: linear-gradient(180deg, rgba(39, 42, 55, 0.98), rgba(25, 27, 37, 0.99));
  border: 1px solid rgba(255, 177, 57, 0.5);
  border-radius: 10px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.72), 0 0 48px rgba(255, 137, 24, 0.12);
}

.pk-result-glow {
  width: 420px;
  height: 210px;
  position: absolute;
  top: -118px;
  left: 50%;
  pointer-events: none;
  transform: translateX(-50%);
  background: radial-gradient(ellipse, rgba(255, 164, 45, 0.42), transparent 68%);
  filter: blur(10px);
}

.pk-result-header {
  position: relative;
  text-align: center;
}

.pk-result-header > span {
  color: #ffb133;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.pk-result-header h2 {
  margin: 7px 0 5px;
  font-size: 25px;
}

.pk-result-header p {
  margin: 0;
  color: #9098aa;
  font-size: 13px;
}

.pk-result-header > button {
  width: 34px;
  height: 34px;
  position: absolute;
  top: -14px;
  right: -14px;
  color: #b8bfcd;
  font-size: 24px;
  line-height: 30px;
  background: #303341;
  border: 1px solid #474b5d;
  border-radius: 5px;
  cursor: pointer;
}

.pk-result-grid {
  margin-top: 26px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.pk-result-count-1 .pk-result-grid {
  width: 100%;
  max-width: 390px;
  margin-right: auto;
  margin-left: auto;
  grid-template-columns: minmax(0, 1fr);
}

.pk-result-count-2 .pk-result-grid {
  width: 100%;
  max-width: 650px;
  margin-right: auto;
  margin-left: auto;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.pk-result-count-3 .pk-result-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.pk-result-grid article {
  min-width: 0;
  padding: 10px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #2b2e3c, #242632);
  border: 1px solid #393d4e;
  border-radius: 6px;
}

.pk-result-art {
  aspect-ratio: 1.42 / 1;
  min-width: 0;
  display: grid;
  place-items: center;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.pk-result-art img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 14px 13px rgba(0, 0, 0, 0.55));
}

.pk-result-grid article > strong {
  margin-top: 8px;
  display: block;
  overflow: hidden;
  color: #f2f3f7;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pk-result-price {
  margin: 7px 0 9px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #ffb33f;
  font-size: 13px;
  font-weight: 900;
}

.pk-result-price i,
.pk-result-total strong i {
  width: 15px;
  height: 15px;
  display: inline-block;
  flex: 0 0 15px;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
  filter: drop-shadow(0 0 5px rgba(255, 156, 31, 0.32));
}

.pk-result-grid article > button {
  width: 100%;
  height: 32px;
  color: #c8ceda;
  font-size: 12px;
  font-weight: 800;
  background: #343746;
  border: 1px solid #484d60;
  border-radius: 4px;
  cursor: pointer;
}

.pk-result-footer {
  margin-top: 22px;
  padding-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-top: 1px solid #383b49;
}

.pk-result-total span {
  display: block;
  color: #8f97a8;
  font-size: 12px;
}

.pk-result-total strong {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffb23e;
  font-size: 21px;
}

.pk-result-actions {
  display: flex;
  gap: 9px;
}

.pk-result-actions button {
  min-width: 122px;
  height: 42px;
  padding: 0 16px;
  color: #f4f5f8;
  font-size: 13px;
  font-weight: 900;
  background: #363948;
  border: 1px solid #4a4f61;
  border-radius: 5px;
  cursor: pointer;
}

.pk-result-actions .pk-result-recycle {
  color: #23180c;
  background: linear-gradient(180deg, #ffc04a, #f28a16);
  border-color: #ffc55c;
}

.pk-result-actions .pk-result-continue {
  color: #fff;
  background: #ff7500;
  border-color: #ff8d28;
}

.pk-open-result button:disabled {
  opacity: 0.55;
  cursor: wait;
}

@media screen and (max-width: 767px) {
  .pk-open-result {
    width: calc(100vw - 20px);
    max-height: calc(100vh - 20px);
    padding: 22px 14px 16px;
  }

  .pk-result-header h2 {
    font-size: 20px;
  }

  .pk-result-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .pk-result-count-1 .pk-result-grid {
    width: 100%;
    max-width: 280px;
    grid-template-columns: minmax(0, 1fr);
  }

  .pk-open-result.pk-result-count-2 .pk-result-grid,
  .pk-open-result.pk-result-count-3 .pk-result-grid,
  .pk-open-result.pk-result-count-4 .pk-result-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .pk-result-art {
    aspect-ratio: 1.24 / 1;
  }

  .pk-result-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .pk-result-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .pk-result-actions button {
    min-width: 0;
  }

  .pk-result-actions .pk-result-continue {
    grid-column: 1 / -1;
  }
}

@media screen and (min-width: 768px) and (max-width: 980px) {
  .pk-open-result.pk-result-count-4 .pk-result-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
